<template>
    <div class="relative border-2 border-dashed rounded-md cursor-pointer p-4 w-240">
        <div v-if="multiple || list.length == 0" droppable="droppable" @dragenter.prevent="dragenter"
             @dragleave.prevent="dragleave" @dragover.prevent="dragover" @drop.prevent="drop"
             :class="{'border-primary-600': highlight}">
            <input class="absolute inset-0 cursor-pointer opacity-0" :id="id" type="file" ref="file" @change="change"
                   :accept="acceptedTypes" />
            <label :for="id">
                <div class="text-center">
                    <div class="line p-3">Drop or select file here...</div>
                    <div class="btn btn-primary">Browse</div>
                </div>
            </label>
        </div>
        <table class="w-full text-sm" v-if="list.length > 0">
            <tr v-for="item in list">
                <td>{{ item.name | filename }}</td>
                <td>{{ item.size | bytes }}</td>
                <td>
                    <div class="sprite-icons-remove cursor-pointer" @click.prevent="remove(item)"></div>
                </td>
            </tr>
        </table>
    </div>
</template>
<script>
let counter = 0

export default {
    name: 'upload',
    props: {
        url: String,
        text: String,
        acceptedTypes: {
            type: String,
            default: ".gif,.jpg,.jpeg,.png,.doc,.docx,.pdf"
        },
        value: null,
        multiple: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            uploaded: null,
            id: `upload-${counter++}`,
            // list: [],
            highlight: false
        }
    },
    computed: {
        list() {
            if (this.value == null || !this.value) {
                return []
            }

            if (this.multiple) {
                var ret = []
                for (var i = 0; i < this.value.length; i++) {
                    var f = this.value[i]
                    ret.push({
                        name: f.name,
                        size: f.size,
                        type: f.type
                    })
                }
                return ret
            }

            return [{
                name: this.value.name,
                size: this.value.size,
                type: this.value.type
            }]
        }
    },
    methods: {
        dragenter() {
            this.highlight = true
        },
        dragleave() {
            this.highlight = false
        },
        dragover() {
            this.highlight = true
        },
        drop(e) {
            this.highlight = false
            let dt = e.dataTransfer
            let files = dt.files
            this.handleFiles(files)
        },
        handleFiles(files) {
            if (!files) {
                return
            }
            // check the file extension manually here
            // as some browsers does not enforce the accept attribute
            const file = files[0];
            const ext = '.' + file.name.split('.').pop().toLowerCase();
            
            if (this.acceptedTypes && !this.acceptedTypes.split(',').includes(ext)) {
                this.$emit('error', 'Invalid file type ' + ext);
                return
            }
            
            if (this.multiple) {
                if (!this.value) {
                    this.value = []
                }
                this.value.push(file);
                this.$emit('input', this.value)
            } else {
                this.$emit('input', file)
            }

        },
        change() {
            this.handleFiles(this.$refs.file.files)
        },
        remove(item) {
            if (this.multiple) {
                var idx = this.list.indexOf(item)
                this.value.splice(idx, 1)
                this.$emit('input', this.value)
            } else {
                this.$emit('input', null)
            }
        }
    }
}
</script>
